import React from 'react';
import { Link } from '@reach/router';
import Testimony from '../components/carouseltestimony';
import Footer from '../components/footer';


export default () => (
<div className='wraperitem'>
  <section className='jumbotron breadcumb' style={{backgroundImage: `url(${'./img/Interior1.jpg'})`}}>
    <div className='mainbreadcumb'>
      <div className='container-fluid'>
        <div className='row m-10-hor'>
          <div className='col-md-6'>
            <h1>Witaly Interior</h1>
          </div>
          <div className='col-md-6'>
            <div className='list'>
              <Link className='link' to="/home">Home</Link>
              <span className='dash'>/</span>
              <span>Witaly Interior</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section className='container-fluid black_more'>
    <div className='row m-10-hor'>
      <div className='col-md-5'>
        <div className='heading'>
          Interiors<span className='br'></span> Built for<span className='br'></span> Living
        </div>
      </div>
      <div className='col-md-7'>
        <div className='content'>
          Witaly Interior is our dedicated residential and commercial interior
          design service — where thoughtful planning meets exceptional craftsmanship.
          We create spaces that are as functional as they are beautiful, tailored
          precisely to the way you live and work.
        </div>
        <div className='content'>
          Whether you are furnishing a new home, refreshing an existing space, or
          designing a high-end commercial environment, our team guides you through
          every decision — from material selection and lighting to bespoke furniture
          and finishing touches.
        </div>
      </div>
    </div>
  </section>

  <section className='container-fluid p-0'>
    <div className='row'>

      <div className="col-md-6 px-0">
        <img src="./img/blog.jpg" className="imgslickz" alt="Interior design showcase"/>
      </div>

      <div className="col-md-6 centered p-md-5 pt-5">
        <div className="p-md-5">
          <div className="subheading">Space Planning</div>
          <div className="heading">
            Form Follows Function
          </div>
          <p className="mt-3">
            Every great interior starts with a clear spatial strategy. We analyse
            how each room will be used and design layouts that maximise flow,
            natural light, and comfort — ensuring beauty never comes at the cost
            of practicality.
          </p>
          <Link className='btn' to="/contact">
            <span className="shine"></span>
            <span>Start a Project</span>
          </Link>
        </div>
      </div>

      <div className="col-md-6 centered p-md-5 pt-5 pb-5">
        <div className="p-md-5">
          <div className="subheading">Material & Finish Selection</div>
          <div className="heading">
            Texture, Tone & Character
          </div>
          <p className="mt-3">
            The materials we choose define how a space feels. From natural stone
            and reclaimed timber to curated fabrics and custom millwork, we source
            premium finishes that bring warmth, depth, and lasting quality to
            every interior we design.
          </p>
          <Link className='btn' to="/works">
            <span className="shine"></span>
            <span>View Portfolio</span>
          </Link>
        </div>
      </div>

      <div className="col-md-6 px-0">
        <img src="./img/blog1.jpg" className="imgslickz" alt="Material and finish selection"/>
      </div>

    </div>
  </section>

  <Testimony />
  <Footer />
</div>

);
